import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';
import { store } from '@/store/configuration';

export function getCurrentSupportUser(): ISupportUser | undefined {
  return store?.getState()?.auth?.currentSupportUser?.state;
}
